import "./App.css";
import Sidebar from "./Components/Sidebar";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./Fonts/MonoSpec-Medium.woff";
import MarketPlace from "./Pages/MarketPlace";
import CreateNft from "./Pages/CreateNft";
import Stacking from "./Pages/Stacking";
import TeleportNft from "./Pages/TeleportNft";
import About from "./Pages/About";
import Contactus from "./Pages/Contactus";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import FeaturedCollectionSeeAll from "./SubComponent/MarketPlace/FeaturedCollectionSeeAll";
import UpcomingCOllectionAll from "./SubComponent/MarketPlace/UpcomingCOllectionAll";
import CreateAccount from "./Pages/CreateAccount";
import TopArtistAll from "./SubComponent/MarketPlace/TopArtistAll";
import Explore from "./Pages/Explore";
import ArtistDetailPage from "./SubComponent/MarketPlace/ArtistDetailPage";
import NftdetailPage from "./SubComponent/MarketPlace/NftdetailPage";

function App() {
  return (
    <div className="back">
      <BrowserRouter>
        <Header />

        <Sidebar>
          <Routes>
            <Route path="/" element={<MarketPlace />} />
            <Route path="/dashboard" element={<MarketPlace />} />
            <Route path="signup" element={<CreateAccount />} />
            <Route path="/nft" element={<CreateNft />} />
            <Route path="/stacking" element={<Stacking />} />
            <Route path="/teleport" element={<TeleportNft />} />
            <Route path="/about" element={<About />} />
            <Route path="/support" element={<Contactus />} />
            <Route path="/explore" element={<Explore />} />
            <Route
              path="/featured-collection"
              element={<FeaturedCollectionSeeAll />}
            />
            <Route
              path="/upcoming-collection"
              element={<UpcomingCOllectionAll />}
            />
            <Route path="/all-topartist" element={<TopArtistAll />} />
            <Route path="/artist-collection" element={<ArtistDetailPage />} />
            <Route path="nft-details" element={<NftdetailPage />} />
          </Routes>
          <Footer />
        </Sidebar>
      </BrowserRouter>
    </div>
  );
}

export default App;
